import { Kind } from '@respond-framework/types';

/**
 * These are the kinds of route transitions where scrolling to the
 * anchor should be animated. It includes transitions that come
 * from a previous route and are new entries, in the sense that
 * they did not previously exist in the history stack.
 */
export const animateHashScrollKinds: Kind[] = ['push', 'replace'];
